<div class="kOverrideFAIcons kContainer">
  <div class="kHeader">
    <kAutoComplete
      [disabled]="!_categoriesLoaded"
      inputStyleClass="kSearchCategory"
      #searchCategory
      field="label"
      placeholder="{{ 'applications.content.filters.findCategory' | translate }}"
      [minLength]="3"
      suggestionSelectableField="isSelectable"
      (onSelect)="_onSuggestionSelected()"
      [suggestionsProvider]="_suggestionsProvider"
      (completeMethod)="_searchSuggestions($event)"
    ></kAutoComplete>
    <i
      #config
      class="kIcongear kTreeConfig"
      [kTooltip]="'applications.content.filters.preferences.preferences' | translate"
    ></i>
    <div class="kAllCategories">
      <span>{{ 'applications.content.filters.allCategories' | translate | uppercase }} </span>
    </div>
  </div>
  <kScrollToTopContainer class="kTreeContainer">
    <k-categories-tree
      #categoriesTree
      [disablePropagation]="selectionMode === _CategoriesModes.Self"
      [selectedCategories]="selection"
      (onCategoriesLoaded)="_categoriesLoaded = true"
      (onCategorySelected)="_onCategorySelected($event)"
      (onCategoryUnselected)="onCategoriesUnselected.emit([$event])"
    >
    </k-categories-tree>
  </kScrollToTopContainer>

  <p>
    <a (click)="_clearAll()">{{ 'applications.content.filters.clearAll' | translate }}</a>
    <a class="kClose" (click)="close()">{{ 'applications.content.filters.close' | translate }}</a>
  </p>
</div>
<kPopupWidget
  #categoriesPref
  data-aid="categoriesPref"
  [popupWidth]="360"
  [popupHeight]="220"
  [closeBtn]="true"
  [closeBtnInside]="true"
  [closeOnResize]="true"
  [targetRef]="config"
  [targetOffset]="{ x: -324, y: -24 }"
  [parentPopup]="parentPopupWidget"
  kSticky
  [stickyClass]="'kForceFix'"
  [stickyId]="'categoriesPref'"
  [sticksTo]="'header'"
  [scrollOffset]="80"
>
  <ng-template>
    <kCategoriesFilterPrefs
      [selectionMode]="selectionMode"
      (selectionModeChange)="_onSelectionModeChanged($event)"
    ></kCategoriesFilterPrefs>
  </ng-template>
</kPopupWidget>
